import React from "react";
import { Checkbox } from 'antd';

import { RegistorClass } from "../core/ComponentRegistor";
const CheckboxGroup = Checkbox.Group;
const plainOptions = ['禁止选择'];
const defaultCheckedList = [];
export class AntCheckboxContainer extends React.Component<any> {
    state = {
        checkedList: defaultCheckedList,
        indeterminate: true,
        checkAll: false,
        discribe: '禁止选择',
    }
    onChange = checkedList => {
        this.setState({
            checkedList,
            indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
            checkAll: checkedList.length === plainOptions.length,
        });
    };

    onCheckAllChange = e => {
        this.setState({
            checkedList: e.target.checked ? plainOptions : [],
            indeterminate: false,
            checkAll: e.target.checked,
        });
    };
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <div style={{ borderBottom: '1px solid #E9E9E9' }}>
                </div>
                {getFieldDecorator(this.props.formKey, {
                    rules: [{
                        validator: this.props.validator
                        // type: this.field.validator, message: 'The input is not valid E-mail!',
                    }, {
                        required: this.props.required, message: '必填项!',
                    }],
                })(
                    <CheckboxGroup
                        options={plainOptions}
                        // disabled={(checkedList == '禁止选择') ? true : false}
                        value={this.state.checkedList}
                        onChange={this.onChange}
                    />)}

            </div>
        );

    }
    handleSizeChange = e => {
        this.setState({ size: e.target.value });
    };
}

let scheme = {
    key: "testsss",
    name: "testNamesss",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
        {
            class: {
                componentTag: "Ant-Checkbox",
            },
            key: "disabled",
            name: "禁止选择(是或否）",
            props: {
                // span: 6,
                plainOptions: ['禁止选择'],
                label: "禁止选择(是或否）"
            }
        },
    ]
}
RegistorClass({
    componentTag: "Ant-CheckboxContainer",
    componentObject: AntCheckboxContainer,
    componentName: "Ant多选框2",
    scheme: scheme,
    defaultProps: {
        span: 24,
        lable: "多选框2",
        required: false
    }
})
// export default AntTextarea